import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const batchDataService = {
    getPropertyDetails: async (address, client = null) => {
        try {
            // Use provided client (authenticated) or fallback to raw axios (unauthenticated)
            const requestor = client || axios;

            // Note: client.get signature matches axios.get
            const response = await requestor.get(`${API_URL}/api/batchdata/property`, {
                params: { address }
            });
            return response.data;
        } catch (error) {
            console.error('BatchData Property Details Error:', error);
            throw error;
        }
    },

    skipTrace: async (address, client = null) => {
        try {
            console.log('[BatchDataService] skipTrace called with:', { address, hasClient: !!client });

            if (client) {
                // Use authenticated ApiClient (expects endpoint only, not full URL)
                console.log('[BatchDataService] Using authenticated contextApiClient');
                const response = await client.post('/api/batchdata/skip-trace', { address });
                console.log('[BatchDataService] Response:', response);
                return response; // ApiClient.post returns parsed JSON directly
            } else {
                // Use raw axios (expects full URL)
                console.log('[BatchDataService] Using raw axios');
                const response = await axios.post(`${API_URL}/api/batchdata/skip-trace`, { address });
                console.log('[BatchDataService] Response:', response);
                return response.data;
            }
        } catch (error) {
            console.error('BatchData Skip Trace Error:', error);
            throw error;
        }
    }
};
